export default __webpack_public_path__ + "static/media/cryptochain-logo.6e202305.png";